import { StageDefinition } from './StageDefinition';

export const stage14: StageDefinition = {
    platforms: [
        [25.263157894736842, 4],
        [31.578947368421055, 4],
        [137.14285714285708, 5],
        [155.45454545454552, 9],
        [159.54545454545462, 9],
        [237.2727272727274, 9],
        [294.54545454545445, 9],
        [343.6363636363632, 9],
    ],
    traps: [
        [232.2580645161291, 0],
        [301.93548387096786, 0],
        [345.6000000000005, 7],
        [351.2195121951213, 8],
        [355.9090909090904, 9],
    ],
    stars: [[344, 10]],
};
